import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constant } from '../common/constant';

export interface VwGlobalSearchResult {
  id: number;
  name: string;
  email?: string;
  contactNo?: string;
  plateNumber?: string;
  location?: string;
  documentId?: string;
  category: string;
  entityType: string;
  url: string;
}

// Backend: GET /api/search/global?q=&accountId= — GlobalSearchController
// already scopes account-tier callers to their own accountId server-side
// (403 if it doesn't match the JWT's account), so this service just has to
// send the account id it already knows about.
@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  constructor(private readonly http: HttpClient) {}

  search(query: string, accountId?: string | number | null): Observable<VwGlobalSearchResult[]> {
    let url = Constant.REST_URL + Constant.SEARCH + Constant.GLOBAL_SEARCH + '?q=' + encodeURIComponent(query);
    if (accountId !== undefined && accountId !== null && accountId !== '') {
      url += '&accountId=' + accountId;
    }
    return this.http.get<VwGlobalSearchResult[]>(url);
  }
}
